import { actionTypes } from '../common/constants/actionTypes';

import EventItemDto from '../api/eventItemDto';
import EventItem from '../api/eventItemEntity';
import NewsCategory from '../api/newsCategoryEntity';
import NewsItemDto from '../api/newsItemDto';
import NewsItem from '../api/newsItemEntity';
import TopicListItemsDto from '../api/topicListItemsDto';

export const eventsAndNewsItemsReducer = (state: any, action: any) => {
  switch (action.type) {
      case actionTypes.FETCH_NEWS_ITEM_BY_ID_COMPLETED:
        const resultNewsItem = handleFetchNewsItemByIdCompleted(state, action.payload);
        return resultNewsItem;
      case actionTypes.FETCH_EVENT_ITEM_BY_ID_COMPLETED:
        const resultEventItem = handleFetchEventItemByIdCompleted(state, action.payload);
        return resultEventItem;
      case actionTypes.FETCH_NEWS_ITEMS:
        const resultnewsItemDto = handleFetchnewsItemDtoCompleted(state, action.payload);
        return resultnewsItemDto;
      case actionTypes.FETCH_EVENT_ITEMS:
        const resultEventItems = handleFetchEventItemsCompleted(state, action.payload);
        return resultEventItems;
      case actionTypes.FETCH_NEWS_CATEGORIES_COMPLETED:
        const resultNewsCategories = handleFetchNewsCategoriesCompleted(state, action.payload);
        return resultNewsCategories;
      case actionTypes.FETCH_EVENT_CATEGORIES_COMPLETED:
        const resultEventCategories = handleFetchEventCategoriesCompleted(state, action.payload);
        return resultEventCategories;
      case actionTypes.FETCH_TOPIC_ITEMS:
        const resultTopicListItems = handleFetchTopicListItemsCompleted(state, action.payload);
        return resultTopicListItems;
  }

  if (state) {
    return state;
  }

  return { latestSelectedNewsItem: new NewsItem(), latestSelectedEventItem: new EventItem(), newsItemDto: new NewsItemDto(), topicListItemsDto: new TopicListItemsDto(), eventItemDto: new EventItemDto(), newsCategories:[], eventCategories:[]  };
};

const handleFetchNewsItemByIdCompleted: (state: any, payload: NewsItem) => any =
function handleItems(state: any, payload: NewsItem): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: payload,
    newsCategories: state.newsCategories,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: state.topicListItemsDto
  }
};
const handleFetchEventItemByIdCompleted: (state: any, payload: EventItem) => any =
function handleItems(state: any, payload: EventItem): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: payload,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: state.newsCategories,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: state.topicListItemsDto
  }
};
const handleFetchnewsItemDtoCompleted: (state: any, payload: NewsItemDto) => any =
function handleItems(state: any, payload: NewsItemDto): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: state.newsCategories,
    newsItemDto: payload,
    topicListItemsDto: state.topicListItemsDto
  }
};
const handleFetchEventItemsCompleted: (state: any, payload: EventItemDto) => any =
function handleItems(state: any, payload: EventItemDto): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: payload,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: state.newsCategories,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: state.topicListItemsDto
  }
};
const handleFetchNewsCategoriesCompleted: (state: any, payload: NewsCategory[]) => any =
function handleItems(state: any, payload: NewsCategory[]): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: payload,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: state.topicListItemsDto
  }
};

const handleFetchEventCategoriesCompleted: (state: any, payload: NewsCategory[]) => any =
function handleItems(state: any, payload: NewsCategory[]): any {
  return {
    eventCategories: payload,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: state.newsCategories,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: state.topicListItemsDto
  }
};

const handleFetchTopicListItemsCompleted: (state: any, payload: TopicListItemsDto) => any =
function handleItems(state: any, payload: TopicListItemsDto): any {
  return {
    eventCategories: state.eventCategories,
    eventItemDto: state.eventItemDto,
    latestSelectedEventItem: state.latestSelectedEventItem,
    latestSelectedNewsItem: state.latestSelectedNewsItem,
    newsCategories: state.newsCategories,
    newsItemDto: state.newsItemDto,
    topicListItemsDto: payload
  }
};


// WEBPACK FOOTER //
// ./src/reducers/eventsAndNewsItems.ts